import type {
  LeaveHistoryKind,
  LeaveStatus,
  LeaveTypeValue,
  ILeaveHistoryEntry,
} from '../types/leave';

export const LEAVE_TYPE_OPTIONS: { value: LeaveTypeValue, label: string }[] = [
  { value: 'paid_leave', label: 'Congés payés' },
  { value: 'unpaid_leave', label: 'Congés sans solde' },
  { value: 'dress_day', label: 'Jour d\'habillage' },
  { value: 'conventional_leave', label: 'Jours conventionnels' },
  { value: 'authorized_unpaid_absence', label: 'Absence autorisée non payée' },
  { value: 'other', label: 'Autre' },
];

export const LEAVE_STATUS_LABELS: Record<LeaveStatus, string> = {
  pending: 'En attente',
  to_plan: 'À planifier',
  approved: 'Planifié',
  rejected: 'Refusée',
  cancelled: 'Annulée',
};

export const leaveTypeLabel = (
  value: string | undefined,
  leaveTypeComment?: string | null,
): string => {
  if (value == null || value === '') return '-';
  if (value === 'other') {
    const c = typeof leaveTypeComment === 'string' ? leaveTypeComment.trim() : '';
    return c ? `Autre (${c})` : 'Autre';
  }
  const opt = LEAVE_TYPE_OPTIONS.find((o) => o.value === value);
  return opt?.label || value;
};

export const leaveStatusLabel = (status: string | null | undefined): string => {
  if (status == null || status === '') return '—';
  return LEAVE_STATUS_LABELS[status as LeaveStatus] || status;
};

export const leaveActorDisplayName = (actor: ILeaveHistoryEntry['actor']): string => {
  if (actor && typeof actor === 'object' && actor.profile) {
    const { firstName = '', lastName = '' } = actor.profile;
    const name = `${firstName} ${lastName}`.trim();
    return name || '-';
  }
  return '-';
};

export const leaveHistorySummary = (
  entry: Pick<ILeaveHistoryEntry, 'kind' | 'fromStatus' | 'toStatus'>,
): string => {
  const { kind, fromStatus, toStatus } = entry;
  switch (kind as LeaveHistoryKind) {
    case 'created':
      return `Création — ${leaveStatusLabel(toStatus)}`;
    case 'cancelled':
      return `Annulation — ${leaveStatusLabel(fromStatus)} → ${leaveStatusLabel(toStatus)}`;
    case 'status_changed':
      return `${leaveStatusLabel(fromStatus)} → ${leaveStatusLabel(toStatus)}`;
    default:
      return kind;
  }
};
